import { Routes } from '@angular/router';

import { authMatchGuard } from '@/app/core/guards/auth-match.guard';
import { guestMatchGuard } from '@/app/core/guards/guest-match.guard';

import { PublicLayoutComponent } from '@/app/layouts/public-layout/public-layout';
import { PrivateLayoutComponent } from '@/app/layouts/private-layout/private-layout';
import { AuthLayoutComponent } from '@/app/layouts/auth-layout/auth-layout';

import { CalculatorFacade } from '@/app/features/pages/public/calculator/calculator.facade';

export const routes: Routes = [
  // PRIVATE
  {
    path: '',
    component: PrivateLayoutComponent,
    canMatch: [authMatchGuard],
    providers: [CalculatorFacade],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@/app/features/pages/private/home/home.routes').then(
            (m) => m.PRIVATE_HOME_ROUTES
          ),
      },

      {
        path: 'locker',
        loadChildren: () =>
          import('@/app/features/pages/private/locker/locker.routes').then(
            (m) => m.PRIVATE_LOCKER_ROUTES
          ),
      },

      {
        path: 'orders',
        loadChildren: () =>
          import('@/app/features/pages/private/orders/orders.routes').then(
            (m) => m.PRIVATE_ORDERS_ROUTES
          ),
      },

      {
        path: 'shipments',
        loadChildren: () =>
          import('@/app/features/pages/private/shipments/shipments.routes').then(
            (m) => m.PRIVATE_SHIPMENTS_ROUTES
          ),
      },

      {
        path: 'calculator',
        loadChildren: () =>
          import('@/app/features/pages/private/calculator/calculator.routes').then(
            (m) => m.PRIVATE_CALCULATOR_ROUTES
          ),
      },
      {
        path: 'calculator-resume',
        loadChildren: () =>
          import('@/app/features/pages/private/calculator-resume/calculator-resume.routes').then(
            (m) => m.PRIVATE_CALCULATOR_RESUME_ROUTES
          ),
      },
      {
        path: 'account',
        loadChildren: () =>
          import('@/app/features/pages/private/account/account.routes').then(
            (m) => m.ACCOUNT_ROUTES
          ),
      },
      {
        path: 'cart',
        loadChildren: () =>
          import('@/app/features/pages/private/cart/cart.routes').then(
            (m) => m.PRIVATE_CART_ROUTES
          ),
      },
      {
        path: 'checkout',
        loadChildren: () =>
          import('@/app/features/pages/private/checkout/checkout.routes').then(
            (m) => m.PRIVATE_CHECKOUT_ROUTES
          ),
      },
      {
        path: 'payment/return',
        loadComponent: () =>
          import('@/app/features/pages/private/payment-return/payment-return.page').then(
            (m) => m.PaymentReturnPage
          ),
      },
      {
        path: 'store',
        loadChildren: () =>
          import('@/app/features/pages/public/store/store.routes').then(
            (m) => m.PUBLIC_STORE_ROUTES
          ),
      },
      {
        path: 'order-confirmed',
        loadChildren: () =>
          import('@/app/features/pages/private/order-confirmed/order-confirmed.routes').then(
            (m) => m.PRIVATE_ORDER_CONFIRMED_ROUTES
          ),
      },

      { path: '**', redirectTo: '' },
    ],
  },

  // AUTH
  {
    path: 'auth',
    component: AuthLayoutComponent,
    canMatch: [guestMatchGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@/app/features/pages/public/auth/auth.routes').then(
            (m) => m.AUTH_ROUTES
          ),
      },
    ],
  },

  // PUBLIC
  {
    path: '',
    component: PublicLayoutComponent,
    providers: [CalculatorFacade],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@/app/features/pages/public/home/home.routes').then(
            (m) => m.PUBLIC_HOME_ROUTES
          ),
      },

      {
        path: 'calculator',
        loadChildren: () =>
          import('@/app/features/pages/public/calculator/calculator.routes').then(
            (m) => m.PUBLIC_CALCULATOR_ROUTES
          ),
      },

      {
        path: 'calculator-resume',
        loadChildren: () =>
          import('@/app/features/pages/public/calculator-resume/calculator-resume.routes').then(
            (m) => m.PUBLIC_CALCULATOR_RESUME_ROUTES
          ),
      },

      {
        path: 'locker',
        loadChildren: () =>
          import('@/app/features/pages/public/locker/locker.routes').then(
            (m) => m.PUBLIC_LOCKER_ROUTES
          ),
      },

      {
        path: 'store',
        loadChildren: () =>
          import('@/app/features/pages/public/store/store.routes').then(
            (m) => m.PUBLIC_STORE_ROUTES
          ),
      },

      {
        path: 'cart',
        loadChildren: () =>
          import('@/app/features/pages/private/cart/cart.routes').then(
            (m) => m.PRIVATE_CART_ROUTES
          ),
      },

      { path: '**', redirectTo: '' },
    ],
  },

  { path: '**', redirectTo: '' },
];
